import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  WizardModalComponent,
  WizardModalData,
} from '@app/shared/components/modals/wizard-modal/wizard-modal.component';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { SharedModule } from '@app/shared/shared.module';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { EventManager } from '@app/shared/utils/event-manager';

@Component({
  selector: 'slotcom-info-daily-challenge',
  templateUrl: './info-daily-challenge.component.html',
  styleUrls: ['./info-daily-challenge.component.scss'],
  standalone: true,
  imports: [CommonModule, ParagraphComponent, SharedModule, WizardModalComponent],
})
export class InfoDailyChallengeComponent implements OnInit {
  dailyChallengeInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private userRepo = inject(UserRepository);

  images: Record<string, string | void> = {};
  wizardModalData: WizardModalData;

  tab = this.dailyChallengeInfoModalData?.data?.streak ? 2 : 0;
  threshold = signal(this.userRepo.getStreak().threshold);

  readonly steps: Record<number, { textStep: string; imgStep: string }[]> = {
    0: [
      { textStep: '.step-1', imgStep: 'one' },
      { textStep: '.step-2', imgStep: 'two' },
      { textStep: '.step-3', imgStep: 'three' },
    ],
    1: [
      { textStep: '.step-4', imgStep: 'four' },
      { textStep: '.step-5', imgStep: 'five' },
      { textStep: '.step-6', imgStep: 'six' },
    ],
    2: [
      { textStep: '-streak.step-1', imgStep: 'seven' },
      { textStep: '-streak.step-2', imgStep: 'eight' },
      { textStep: '-streak.step-3', imgStep: 'nine' },
    ],
  };

  ngOnInit(): void {
    this.wizardModalData = new WizardModalData(
      NonPersistedModalName.InfoDailyChallengeComponent,
      ModalType.View,
      [
        { buttonText: '', closeable: true, imageUrl: '' },
        { buttonText: '', closeable: true, imageUrl: '' },
        { buttonText: '', closeable: true, imageUrl: '' },
      ],
      true,
      null
    );
  }

  tabChanged(tab: number): void {
    this.tab = tab;
  }

  closeInfo() {
    this.eventManager.closeModal(
      new Modal(this.dailyChallengeInfoModalData.id, ModalType.Info, this.dailyChallengeInfoModalData)
    );
  }
}
